import { type FC, memo } from 'react';

import rejectedAsset from '../../assets/images/rejected_asset.png';
import VideoPlayer from '../VideoPlayer';

export type RejectedThumbnailProps = {
  sourceUrl: string | undefined | null;
  className?: string;
  hideBlockClassName?: string;
  hideControl?: boolean;
  NoPreviewComponent?: JSX.Element;
};

const RejectedThumbnail: FC<RejectedThumbnailProps> = ({
  sourceUrl,
  className,
  hideControl = false,
  NoPreviewComponent,
}): JSX.Element => {
  const NoPreview: JSX.Element = !!NoPreviewComponent ? (
    NoPreviewComponent
  ) : (
    <img src={rejectedAsset} alt="rejected" data-testid="rejectedThumbnail" className={className} />
  );
  return !sourceUrl ? NoPreview : <VideoPlayer hideControl={hideControl} src={sourceUrl} className={className} />;
};

export default memo(RejectedThumbnail);
